/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies and Tracking Technologies`)
};

const es_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies y Tecnologías de Rastreo`)
};

const de_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies und Tracking-Technologien`)
};

const nl_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies en trackingtechnologieën`)
};

const fr_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies et technologies de suivi`)
};

const it_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookie e tecnologie di tracciamento`)
};

const pt_br2_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies e tecnologias de rastreamento`)
};

const pt_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies e tecnologias de rastreamento`)
};

const ja_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookieおよびトラッキング技術`)
};

const zh_privacy_section_4_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookie和跟踪技术`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_4_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_4_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_4_title", locale)
	if (locale === "en") return en_privacy_section_4_title(inputs)
	if (locale === "es") return es_privacy_section_4_title(inputs)
	if (locale === "de") return de_privacy_section_4_title(inputs)
	if (locale === "nl") return nl_privacy_section_4_title(inputs)
	if (locale === "fr") return fr_privacy_section_4_title(inputs)
	if (locale === "it") return it_privacy_section_4_title(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_4_title(inputs)
	if (locale === "pt") return pt_privacy_section_4_title(inputs)
	if (locale === "ja") return ja_privacy_section_4_title(inputs)
	return zh_privacy_section_4_title(inputs)
};